/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import hotQuestions from 'images/coin-pages/questions/hot.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const hotPage: ICoinPageData = {
  title: 'coin_471',
  description: 'coin_472',
  // description:
  //   'Borrow Holo against Stablecoins.' +
  //   ` Get a stablecoin loan using your HOT coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Holo (HOT)' }) }} />
  ),
  questionsBlock: {
    image: hotQuestions,
    questions: [
      {
        title: 'coin_473',
        answer: 'coin_474',
      },
      {
        title: 'coin_475',
        answer: 'coin_476',
      },
      {
        title: 'coin_477',
        answer: 'coin_478',
      },
      {
        title: 'coin_479',
        answer: 'coin_480',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Holo (HOT)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_481',
        text: ['coin_483'],
      },
      {
        title: 'coin_482',
        text: ['coin_484', 'coin_485', 'coin_486', 'coin_487'],
      },
    ],
    ...commonLearnMoreData('Holo (HOT)'),
  },
}
